import './RequiresAviotrackBanner.css';

/**
 * Shown at the top of pages that only work for receivers running the Aviotrack
 * receiver software (Performance, Device). A readsb/dump1090 or ACARS-only
 * feeder never sends the STATS heartbeat those pages are built on, so say why
 * the page is empty and point at the install instructions.
 *
 * @param {string|null} latestVersion  latest release from the manifest ("1.05.24")
 * @param {function} onNavigate        App navigation: onNavigate('downloads', {tab})
 * @param {string} [installTab]        Downloads tab to land on
 */
function RequiresAviotrackBanner({ latestVersion, onNavigate, installTab = 'install-linux' }) {
  const version = latestVersion ? `v${latestVersion}` : 'the current release';
  const go = (e) => {
    e.preventDefault();
    if (onNavigate) onNavigate('downloads', { tab: installTab });
  };
  return (
    <div className="requires-aviotrack-banner" role="note">
      <strong>Requires Aviotrack Receiver software {version} or greater.</strong>{' '}
      This receiver has not reported as the Aviotrack receiver, so there is nothing to show here yet.{' '}
      {onNavigate
        ? <a href="/downloads" onClick={go}>Click here for install instructions</a>
        : <span>See the Downloads page for install instructions</span>}
      .
    </div>
  );
}

export default RequiresAviotrackBanner;
